<template>
  <section class="mt-2">
    <template>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-col justify="end">
        <v-btn
          depressed
          class="text-capitalize"
          small
          color="primary"
          @click="openFormDialog"
        >
          <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon>Add
          Category
        </v-btn>
      </v-col>
    </template>
    <v-dialog persistent v-model="formDialogVisible" max-width="400px">
      <v-card>
        <v-form ref="form" v-model="valid">
          <v-toolbar color="grey lighten-3 font-weight-bold " flat dense>
            <span class="subtitleFontsize"
              ><v-icon small>mdi-content-save-plus-outline</v-icon>Add</span
            >
            <v-spacer></v-spacer>
            <v-btn depressed small icon @click="closeFormDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-0">
            <v-row no-gutters>
              <v-col cols="12" md="12">
                <v-radio-group v-model="selectpamaterType" row>
                  <v-radio label="New parameter" value="new"></v-radio>
                  <v-radio label="Existing parameter" value="exist"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="12" v-if="selectpamaterType === 'exist'">
                <label class="my-0 rounded labelFontsize">Name </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  v-model="existedparameter"
                  :items="parametersList"
                  item-text="text"
                  item-value="value"
                  :rules="Name"
                  outlined
                  placeholder="Select Parameter"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="12" v-else>
                <label class="my-0 rounded labelFontsize"> Name </label>
                <v-text-field
                  :rules="Name"
                  dense
                  outlined
                  v-model="prameterdetails.parameter_name"
                  placeholder="Name"
                  class="rounded"
                  @input="validateparameterName()"
                >
                </v-text-field>
                <p
                  v-if="prameterdetails.parameter_name"
                  v-bind:style="{
                    color: isnameavalaible.success
                      ? 'green !important'
                      : ' red !important',
                  }"
                  class="pa-0 ma-0 caption"
                >
                  {{ isnameavalaible.message }}
                </p>
                <label class="my-0 rounded labelFontsize">
                  Parameter Code
                </label>
                <v-text-field
                  placeholder="Parameter Code"
                  dense
                  outlined
                  :rules="parametercode"
                  @input="validateparameterCode()"
                  v-model="prameterdetails.parameter_code"
                  class="rounded"
                ></v-text-field>
                <p
                  v-if="prameterdetails.parameter_code"
                  :style="{
                    color: isavalaiblevalue.success
                      ? 'green !important'
                      : ' red !important',
                  }"
                  class="pa-0 ma-0 caption"
                >
                  {{ isavalaiblevalue.message }}
                </p>
                <label class="my-0 rounded labelFontsize"> Description </label>
                <v-text-field
                  placeholder="Description"
                  v-model="prameterdetails.description"
                  :rules="descrption"
                  dense
                  outlined
                  class="rounded"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              depressed
              small
              color="primary"
              class="text-capitalize"
              outlined
              @click="closeFormDialog"
            >
              <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
            </v-btn>
            <v-btn
              depressed
              @click="
                selectpamaterType === 'exist'
                  ? AddExistingParameter(existedparameter)
                  : AddnewParameter()
              "
              small
              color="primary"
              class="text-capitalize"
            >
              <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon
              >Add
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import { Masterdata } from "@/utils/validationCopy.js";
import Loading from "vue-loading-overlay";
import setupService from "@/services/SetupService/setupService.js";

export default {
  name: "Addmastercat",
  mixins: [alerts],
  data() {
    return {
      ...Masterdata,
      valid: true,
      formDialogVisible: false,
      selectpamaterType: "new",
      parametersList: [],
      prameterdetails: {
        parameter_name: "",
        parameter_code: "",
        description: "",
      },
      loader: false,
      isavalaiblevalue: {},
      isnameavalaible: {},
    };
  },
  props: {
    selectedItems: {
      type: Array,
    },
    prameterid: {
      type: String,
    },
  },
  components: {
    Loading,
  },
  mounted() {
    this.getallparameters();
  },
  computed: {},
  methods: {
    openFormDialog() {
      this.formDialogVisible = true;
    },
    closeFormDialog() {
      this.formDialogVisible = false;
    },
    //--------------------POST API"S START------------------------------- //

    //-------------------- for adding new parameter------------------------------- //
    async AddExistingParameter(parameter_id) {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.loader = true;
        try {
          const responseData = await setupService.addExistingParameterDetails(
            parameter_id,
            this.prameterid,
            this.selectedItems
          );
          console.log(`responseData master: ${responseData.data}`);
          if (responseData && responseData.data.status_code == 200) {
            this.showAlertSuccess(responseData.data.message);
            this.$refs.form.reset();
            this.closeFormDialog();
            setTimeout(() => {
              this.loader = false;
            }, 400);
          }
          //  else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.postList();
          // }
          else {
            this.showAlertError(`Failed:${responseData.data.message}`);
            this.loader = false;
          }
          console.log("respose data", responseData);
        } catch (e) {
          console.log(e);
          this.showAlertError("Something went wrong please try again later.");
          this.loader = false;
        }
      }
    },
    async AddnewParameter() {
      const validate = this.$refs.form.validate();
      if (
        validate &
        this.isnameavalaible.success &
        this.isavalaiblevalue.success
      ) {
        this.loader = true;
        try {
          const responseData = await setupService.addParameterDetails(
            this.prameterdetails
          );
          console.log(`responseData master: ${responseData.data}`);
          if (responseData && responseData.data.status_code == 200) {
            this.showAlertSuccess(responseData.data.message);
            this.AddExistingParameter(responseData.data.data[0].id);
            setTimeout(() => {
              this.loader = false;
            }, 400);
          }
          //  else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.postList();
          // }
          else {
            this.showAlertError(`Failed:${responseData.data.message}`);
            this.loader = false;
          }
        } catch (e) {
          console.log(e);
          this.showAlertError("Something went wrong please try again later.");
          this.loader = false;
        }
      }
    },
    //--------------------POST API"S  END------------------------------- //
    //--------------------GET API"S START------------------------------- //
    //-------------------- Validate parameter code is available or not------------------------------- //

    async validateparameterCode() {
      try {
        const responseData = await setupService.getValidateParameterCode(
          this.prameterdetails.parameter_code
        );
        if (responseData.data.status_code === 200) {
          this.isavalaiblevalue = responseData.data;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.validateparameterCode();
        // }
        else if (responseData.data.status_code == 409) {
          this.isavalaiblevalue = responseData.data;
        }
        console.log("validateparameterCode", responseData);
      } catch (e) {
        console.log("ss " + e);
        this.isnameavalaible = {
          message: "Something went wrong",
          data: [],
          status_code: 409,
          success: false,
        };
      }
    },
    async validateparameterName() {
      try {
        const responseData = await setupService.getValidateParameterName(
          this.prameterdetails.parameter_name
        );
        if (responseData.data.status_code === 200) {
          this.isnameavalaible = responseData.data;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.validateparameterCode();
        // }
        else if (responseData.data.status_code == 409) {
          this.isnameavalaible = responseData.data;
        }
        console.log("validateparameterCode", responseData);
      } catch (e) {
        console.log("ss " + e);
        this.isnameavalaible = {
          message: "Something went wrong",
          data: [],
          status_code: 409,
          success: false,
        };
      }
    },
    async getallparameters() {
      this.isLoading = true;
      try {
        const responseData = await setupService.getExistingParameters();
        if (responseData.data.status_code === 200) {
          this.parametersList = responseData.data.data.map((ele) => {
            return {
              value: ele.id,
              text: ele.parameter_name,
            };
          });
          this.isLoading = false;
        }
        console.log("respose data", responseData);
      } catch (e) {
        this.isLoading = false;
        console.error(e);
      }
    },
  },
};
</script>

<style></style>
